import { Notification } from 'src/constants/notifications';
import i18n from 'src/utils/translate';

export const digestFrequencies = [
  {
    notificationId: Notification.NewDailyCommunityActivitySummary,
    text: i18n.t('Daily'),
  },
  {
    notificationId: Notification.WeeklyCommunityActivitySummary,
    text: i18n.t('Weekly'),
  },
  {
    notificationId: Notification.MonthlyCommunityActivitySummary,
    text: i18n.t('Monthly'),
  },
];

export const digestIds = [
  Notification.DailyCommunityActivitySummary,
  Notification.NewDailyCommunityActivitySummary,
  Notification.WeeklyCommunityActivitySummary,
  Notification.MonthlyCommunityActivitySummary,
];

export const emailTypes = [
  {
    notificationId: Notification.NewPost,
    emailType: 'Community',
    notificationType: 'NewPost',
    text: i18n.t("When someone creates a post in my communities (not recommended if you're in a large community)"),
  },
  {
    notificationId: Notification.NewPoll,
    emailType: 'Community',
    notificationType: 'NewPoll',
    text: i18n.t('When someone creates a poll in my communities'),
  },
  {
    notificationId: Notification.ResponsesToMyPost,
    emailType: 'Account',
    notificationType: 'ResponsesToMyPost',
    text: i18n.t("When someone responds to something I've written"),
  },
  {
    notificationId: Notification.PrivateMessage,
    emailType: 'Account',
    notificationType: 'PrivateMessage',
    text: i18n.t('When someone sends me a private message'),
  },
  {
    notificationId: Notification.DailyCommunityActivitySummary,
    emailType: 'Digest',
    notificationType: 'DailyCommunityActivitySummary',
    text: i18n.t('Daily selection of top posts'),
  },
  {
    notificationId: Notification.WeeklyCommunityActivitySummary,
    emailType: 'Digest',
    notificationType: 'WeeklyCommunityActivitySummary',
    text: i18n.t('Weekly selection of top posts'),
  },
  {
    notificationId: Notification.HuAnnouncements,
    emailType: 'HealthUnlocked',
    notificationType: 'HuAnnouncements',
    text: i18n.t('Tips on getting more out of HealthUnlocked'),
  },
  {
    notificationId: Notification.HuResearchEmails,
    emailType: 'HealthUnlocked',
    notificationType: 'HuResearchEmails',
    text: i18n.t('Opportunities (e.g. surveys, clinical trials, paid market research, new patient communities) that might interest me.'),
  },
  {
    notificationId: Notification.FollowedUserActivity,
    emailType: 'Account',
    notificationType: 'FollowedUserActivity',
    text: i18n.t('When someone I follow writes a new post'),
  },
  {
    notificationId: Notification.FollowedPostActivity,
    emailType: 'Account',
    notificationType: 'FollowedPostActivity',
    text: i18n.t("When a post I've saved has new replies"),
  },
  {
    notificationId: Notification.UserMentions,
    emailType: 'Account',
    notificationType: 'UserMentions',
    text: i18n.t('Someone mentions me in a post or comment'),
  },
  {
    notificationId: Notification.MonthlyCommunityActivitySummary,
    emailType: 'Digest',
    notificationType: 'MonthlyCommunityActivitySummary',
    text: i18n.t('Monthly selection of top posts'),
  },
  {
    notificationId: Notification.NewDailyCommunityActivitySummary,
    emailType: 'Digest',
    notificationType: 'NewDailyCommunityActivitySummary',
    text: i18n.t('Daily list of all new posts'),
  },
  {
    notificationId: Notification.CanYouHelpX,
    emailType: 'Community',
    notificationType: 'CanYouHelpX',
    text: i18n.t('When someone writes a post or question I might be able to answer'),
  },
  {
    notificationId: Notification.Programs,
    emailType: 'Account',
    notificationType: 'Programs',
    text: i18n.t('When a program I am enrolled in needs to be completed'),
  },
  {
    notificationId: Notification.CommunityInvitations,
    emailType: 'Community',
    notificationType: 'CommunityInvitations',
    text: i18n.t(`When you've been invited to a private HealthUnlocked community`),
  },
];
